import { IGeoDetail } from 'shared/types/geoSuggest';
import { ILocation } from 'shared/types/location';

export function createLocationModel(detail: IGeoDetail): ILocation {
  return {
    ...detail.locationInfo,
    displayName: detail.fullName,
    name: detail.name,
    id: detail.id,
    fullName: detail.fullName,
  };
}
